import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65b2fa00&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=65b2fa00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2fa00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b2fa00')) {
      api.createRecord('65b2fa00', component.options)
    } else {
      api.reload('65b2fa00', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=65b2fa00&scoped=true&", function () {
      api.rerender('65b2fa00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Settings/index.vue"
export default component.exports